import { COMMON_STATUS, languages } from "constants/constants";

export interface CategoryQuery {
	skip: number;
	take: number;
	name?: string;
	status: string | null;
	sortColumn: string;
	order: string;
	language: string;
}

export interface CategoryTranslations {
	language: string;
	name: string;
}

export interface CategoryDetail {
	id: number;
	image: string;
	name: string;
	order?: number | null;
	status: string | boolean;
	createAt?: string;
	updateAt?: string;
	bodyTypes: string[];
	translations: CategoryTranslations[];
}

export interface GetListCategoryAsyncParams {
	query: CategoryQuery;
	callback: () => void;
}

export interface GetDetailCategoryAsyncParams {
	id: number;
	callback: () => void;
}

export interface CreateCategoryAsyncParams {
	data: CategoryDetail;
	callback: () => void;
}

export interface UpdateCategoryAsyncParams {
	id: number;
	data: CategoryDetail;
	callback?: () => void;
}

export const CategoryDefault: CategoryDetail = {
	id: 0,
	image: "",
	name: "",
	status: COMMON_STATUS.enabled.value,
	bodyTypes: [],
	translations: languages.map(lang => ({
		name: "",
		language: lang.key,
	})),
};
